module.exports = __webpack_public_path__ + "img/prize-car.aee8b724.png";